<template>
<!--分学银行-->
  <div class="content">
    <headers></headers>
    <div class="nav">
      <div class="auto">行业证书  >  操作指南  >  证书信息登记  >  我的证书 </div>
    </div>
    <div class="auto padding250">
       <p class="title">我的证书</p>
      <div class="container ">
        <div style="display: none;">
          <p class="img"><img src="../../assets/zhengshu4.png" alt=""></p>
          <p class="tip" style="display: none;">根据中国物业管理协会要求，由中物协及各省市协会颁发的项目经理职业资格证书，必须在2022年12月31日前统一更换新证，旧证书即行废止。“原项目经理证书”对应“现项目经理证书”</p>
        </div>

        <div class="contents">
          <p class="title">物业管理项目经理岗位技能证书</p>
          <ul>
          	<li><span>姓      名</span> 王小东</li>
            <li><span>身份证号</span>211002199005061977</li>
            <li><span>颁证机构</span> 110102295637900</li>
            <li><span>证书名称</span> <p>物业项目运营管理(非统设选修)</p></li>
            <li><span>证书编号</span><p>全国物业行业项目经理职业资格证书</p> </li>
            <li><span>颁证日期</span> 5分</li>
            <li><span>证书有效期</span>2019年10月20日</li>
          </ul>
        </div>
        <p >
          <router-link to="/step" style="display: none;">证书换新</router-link>
          <router-link to="/step">学分认定</router-link>
        </p>

      </div>
      <Modal class-name="vertical-center-modal" v-model="ishsow" footer-hide width="580px">
        <ul class="model_content">
          <li class="title">学分认定重要提示</li>
          <li class="tip">学员学分认定首先需要在国家开放大学注册账户，并注册学籍...</li>
          <li><router-link to="/confirmrending">确定</router-link></li>

        </ul>
      </Modal>
    </div>
    <footers></footers>
  </div>
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
  .contents{
   background: url('../../assets/zhengshubg.png') no-repeat;
   width: 490px;
   height: 626px;
    padding-top: 50px;
    margin:0px auto 50px;
    text-align: left;
   .title{
      font-size: 30px;
      color: #333;

      margin:35px auto;
      text-align: center;
      // width: 240px;
      font-weight: 700;
   }
   li{
      font-size: 17px;
      color: #666;
      padding:0 60px;
      margin-bottom: 12px;
      span{
        color: #000;
        display: inline-block;
        width: 135px;
      }
      p{
        width: 224px;
        vertical-align: top;
        display: inline-block;
        span{
          color: #244068;
          display: inline;
        }
      }
   }
  }
  .model_content{
    text-align: center;
    padding-bottom: 30px;
    .title{
      font-size: 24px;
      color: #333;
      padding-top: 30px;
    }
    .tip{
        font-size: 16px;
        color: #666;
        margin: 40px 0 100px;
    }
    a{
      color: #fff;
      display: inline-block;
      width: 190px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      border-radius: 5px;
      font-size: 16px;
      background-color: #957960;
    }
  }
  .nav{
    color: #fff;
    background-color: #2F261E;
    height: 60px;
    line-height: 60px;
    font-size: 16px;
  }
  .content{
    background-color: #f5f5f5;
    text-align: left;
    .title{
      font-size: 26px;
      color: #000;
      margin-top: 30px;
    }
    .container{
      background-color: #fff;
      padding: 50px 30px;
      margin-top: 10px;
      text-align: center;
      .tip{
        font-size: 14px;
        color: #999;
        margin:20px auto 0px;
        width: 660px;
         text-align: left;
      }
      a{
        margin-top: 40px;
        color: #fff;
        display: inline-block;
        width: 220px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        border-radius: 5px;
        font-size: 16px;
        background-color: #073C68;
      }
    }
  }
</style>
<script type="text/ecmascript-6">
  import headers from '../template/header'
  import footers from '../template/footer'

    export default {
        name: 'fenxue',
        props: {},
        data() {
            return {
              ishsow:true,
            };
        },
        methods: {},
        created() {

        },
        components: {
          headers,
          footers

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/changeScore/zhengshu.vue